import React from "react";
import { H1, GradientSpan, D1 } from "../components/theme/text/Headings";
import logoImg from "../images/logo/v.png";
import matchImage from "../images/matchImage.png";
import download from "../images/Download.svg";
import { Blue, Pink, White } from "../components/theme/colors";

const DownloadVibeCheck = () => {
  return (
    <div
      style={{
        position: "relative",
        minHeight: "100vh",
        backgroundColor: "#000",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
      }}
    >
      {/* Content container */}
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* Logo and title */}
        <img src={logoImg} alt="Vibe Check Logo" style={{ height: "80px" }} />

        <D1 className="mb-30" color={White}>
          Vibe Check
        </D1>
        {/* Main heading */}
        <H1 className="mb-10 mt-10" color={White}>
          Send a link.
        </H1>

        {/* Gradient tagline */}
        <H1 className="mb-50">
          <GradientSpan $background={Blue} $transitionBackground={Pink}>
            Discover who they really are.
          </GradientSpan>
        </H1>

        {/* App Store download badge */}
        <a
          href="https://apps.apple.com/us/app/vibe-check-compatibility-quiz/id6755138167"
          target="_blank"
          rel="noopener noreferrer"
          style={{ marginBottom: "30px" }}
        >
          <img
            src={download}
            alt="Download on App Store"
            style={{ height: "50px" }}
          />
        </a>
      </div>

      {/* Match image - full width at bottom */}
      <div style={{ width: "100%" }}>
        <img
          src={matchImage}
          alt="Match comparison"
          style={{ width: "100%", height: "auto", display: "block" }}
        />
      </div>
    </div>
  );
};

export default DownloadVibeCheck;
